import React from 'react';

const DEBUG = false;
// const DEBUG = "LayoutItemView";

export default class LayoutItemView extends React.Component<any> {

    private $ivContainer    : any

    constructor(props:any) {
        super(props);

        this.state = {
            domContainers: []
        }

        this.$ivContainer = null;

        gd.itemView.layoutManager = this;
    }

    componentDidMount() {
        // @ts-ignore
        this.$ivContainer = $("#ui-iv-container");
    }

    toggleContainerEmptyClass(isEmpty:boolean) {
        isEmpty && !this.$ivContainer.hasClass('empty') && this.$ivContainer.addClass('empty')
        !isEmpty && this.$ivContainer.removeClass('empty')

        gd.bus.triggerEvent('layout-item-view-toggle');
    }

    createContainer(domElementId:string) {
        this.$ivContainer.append("<div id='"+domElementId+"' class='iv-view'/>");
    }

    destroyContainer(containerId:string) {

        DEBUG && console.log(DEBUG, ".destroyContainer()", containerId)

        // @ts-ignore
        const $itemViewContainer = $("#" + containerId);
        $itemViewContainer.empty();
        $itemViewContainer.remove();
    }

    render() {
        return (
            <div id="ui-iv-container" className="empty"/>
        )
    }
}